import { IDeleteContratoFinanceiroUseCase } from "../../../presentation/useCases/delete/delete_contrato_financeiro_use_case";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";

/**
 * DeleteContratoFinanceiroUseCase
 */

export class DeleteContratoFinanceiroUseCase implements IDeleteContratoFinanceiroUseCase {
  constructor(private readonly repository: IFinanceiroRepository) { }

  async deleteContratoFinanceiro(idContrato: number): Promise<void> {
    await this.repository.deleteContratoFinanceiro(idContrato);

  }
}
